import { canvasVecToLocal } from '@/lib/transforms/geometry'
import type { UnifiedSelectionResizeHandle } from '@/lib/transforms/types/unified-selection-resize-handle'

/** Same transform as pointer deltas in `shape-manager` multi-select resize. */
export function canvasDeltaToMultiResizeLocal(
  dx: number,
  dy: number,
  rotationDeg: number
): { x: number; y: number } {
  return canvasVecToLocal({ x: dx, y: dy }, rotationDeg)
}

/** Fixed point (multi-select chrome-local, center-relative) for the opposite edge/corner when resizing. */
export function getMultiResizeFixedAnchorLocal(
  direction: UnifiedSelectionResizeHandle,
  width: number,
  height: number
): { x: number; y: number } {
  const hw = width / 2
  const hh = height / 2
  const isCorner =
    (direction.includes('n') || direction.includes('s')) &&
    (direction.includes('e') || direction.includes('w'))

  if (isCorner) {
    if (direction === 'nw') return { x: hw, y: hh }
    if (direction === 'ne') return { x: -hw, y: hh }
    if (direction === 'sw') return { x: hw, y: -hh }
    if (direction === 'se') return { x: -hw, y: -hh }
  }

  if (direction === 'n') return { x: 0, y: hh }
  if (direction === 's') return { x: 0, y: -hh }
  if (direction === 'e') return { x: -hw, y: 0 }
  if (direction === 'w') return { x: hw, y: 0 }
  return { x: 0, y: 0 }
}
